import * as types from './types';
import * as moment from 'moment';

const INITIAL_STATE = {
  fetching: false,
  error: null,
  data: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.PROCESSED_DOCUMENTS_FETCH_ERROR:
      return { ...state, error: payload };
    case types.PROCESSED_DOCUMENTS_FETCHING:
      return { ...state, fetching: payload };
    case types.GET_PROCESSED_DOCUMENTS:
      return {
        ...state,
        data: payload.map(i => {
          return {
            ...i,
            CompletedDT: moment(i.CompletedDT),
            CreatedDT: moment(i.CreatedDT),
          };
        }),
      };
    case types.PROCESSED_DOCUMENTS_GET_DATA:
      return {
        ...state,
        data: state.data.map(
          d => (d.Id === payload.Id ? { ...d, Data: payload.Data } : d)
        ),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/processeddocuments/state/page/reducer.js